<div class="modal-header">
  <h4 class="modal-title">
    {{ 'admintool.save.article.title' | translate }}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p class="pre-wrap break-word">{{ 'admintool.save.article.message' | translate }}</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button"
          class="btn btn-secondary btn-cancel"
          (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button type="button"
          class="btn btn-secondary"
          (click)="saveAsNewVersion()">
    {{'admintool.save.article.button.newVersion' | translate}}
  </button>
  <button type="button"
          class="btn btn-primary"
          (click)="override()">
    {{ 'admintool.save.article.button.overwrite' | translate}}
  </button>
</div>
